/*
 * CreateItemPage Messages
 *
 * This contains all the text for the CreateItemPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.CreateItemPage';

export default defineMessages({
  feedbackManagement: {
    id: `${scope}.feedbackManagement`,
    defaultMessage: 'Quản lý đánh giá',
  },
  feedbackList: {
    id: `${scope}.feedbackList`,
    defaultMessage: 'Danh sách đánh giá',
  },
  searchFeedbackPlaceHolder: {
    id: `${scope}.searchFeedbackPlaceHolder`,
    defaultMessage: 'Tìm kiếm theo mã phiếu hàng, khách hàng',
  },
  allOption: {
    id: `${scope}.allOption`,
    defaultMessage: 'Tất cả',
  },
  star: {
    id: `${scope}.star`,
    defaultMessage: 'Sao: ',
  },
  oneStar: {
    id: `${scope}.oneStar`,
    defaultMessage: '1 sao',
  },
  twoStars: {
    id: `${scope}.twoStars`,
    defaultMessage: '2 sao',
  },
  threeStars: {
    id: `${scope}.threeStars`,
    defaultMessage: '3 sao',
  },
  fourStars: {
    id: `${scope}.fourStars`,
    defaultMessage: '4 sao',
  },
  fiveStars: {
    id: `${scope}.fiveStars`,
    defaultMessage: '5 sao',
  },
  displayActive: {
    id: `${scope}.displayActive`,
    defaultMessage: 'Hiển thị',
  },
  displayHidden: {
    id: `${scope}.displayHidden`,
    defaultMessage: 'Đã ẩn',
  },
  displayDeleted: {
    id: `${scope}.displayDeleted`,
    defaultMessage: 'Đã xoá',
  },
  feedbackStatus: {
    id: `${scope}.feedbackStatus`,
    defaultMessage: 'Trạng thái: ',
  },
  feedbackStar: {
    id: `${scope}.feedbackStar`,
    defaultMessage: 'Sao: ',
  },
  feedbackTime: {
    id: `${scope}.feedbackTime`,
    defaultMessage: 'Thời gian đánh giá',
  },
  feedbackDeliveryId: {
    id: `${scope}.feedbackDeliveryId`,
    defaultMessage: 'Mã đơn hàng',
  },
  feedbackRating: {
    id: `${scope}.feedbackRating`,
    defaultMessage: 'Đánh giá',
  },
  feedbackContent: {
    id: `${scope}.feedbackContent`,
    defaultMessage: 'Nội dung',
  },
  feedbackAuthor: {
    id: `${scope}.feedbackAuthor`,
    defaultMessage: 'Người đăng',
  },
  feedbackStore: {
    id: `${scope}.feedbackStore`,
    defaultMessage: 'Cửa hàng',
  },
  feedbackStatusHeader: {
    id: `${scope}.feedbackStatusHeader`,
    defaultMessage: 'Trạng thái',
  },
  searchByProductQuery: {
    id: `${scope}.searchByProductQuery`,
    defaultMessage: 'Tìm kiếm theo id, tên sản phẩm',
  },
  hideRatingTitle: {
    id: `${scope}.hideRatingTitle`,
    defaultMessage: 'Ẩn đánh giá này',
  },
  hideRatingContent: {
    id: `${scope}.hideRatingContent`,
    defaultMessage:
      'Đánh giá sẽ không còn hiển thị công khai trên trang chi tiết sản phẩm, nhưng vẫn được lưu lại trong hệ thống để quản lý nội bộ.',
  },
  deleteRatingTitle: {
    id: `${scope}.deleteRatingTitle`,
    defaultMessage: 'Xoá đánh giá này?',
  },
  deleteRatingContent: {
    id: `${scope}.deleteRatingContent`,
    defaultMessage: 'Đánh giá sẽ bị xoá vĩnh viễn khỏi hệ thống và bạn sẽ không thể khôi phục lại.',
  },
  hideRatingOkButton: {
    id: `${scope}.hideRatingOkButton`,
    defaultMessage: 'Ẩn đánh giá',
  },
  deleteRatingOkButton: {
    id: `${scope}.deleteRatingOkButton`,
    defaultMessage: 'Xóa đánh giá',
  },
  productName: {
    id: `${scope}.productName`,
    defaultMessage: 'Tên sản phẩm',
  },
  anonymousText: {
    id: `${scope}.anonymousText`,
    defaultMessage: 'Ẩn danh',
  },
  media: {
    id: `${scope}.media`,
    defaultMessage: 'Hình ảnh, Video',
  },
});
